import { Spinner } from "@cohesive/ui-components";
import React from "react";

interface WorkspaceShellProps {
  isLoading?: boolean;
  children: React.ReactNode;
}

/**
 * Workspace page chrome (loading, select-none). Drag-and-drop is handled
 * by the app-wide `TransferDndProvider` in `WorkspaceLayout`.
 */
export function WorkspaceShell({
  isLoading = false,
  children,
}: WorkspaceShellProps) {
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden select-none">
      {isLoading ? (
        <div className="flex flex-1 items-center justify-center">
          <Spinner size="lg" />
        </div>
      ) : (
        children
      )}
    </div>
  );
}
